module.exports = __webpack_public_path__ + "img/zhyly-3.6ac4ffcc.png";